<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('mis.rebateComponents.add') : $t('mis.rebateComponents.update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="'200px'"
    >
      <el-form-item :label="$t('mis.rebateComponents.activeName')" prop="activeName">
        <el-input v-model="dataForm.activeName" :placeholder="$t('mis.rebateComponents.activeName')" :disabled="detail"></el-input>
      </el-form-item>

      <el-form-item :label="$t('mis.rebateComponents.activeId')" prop="activeId">
        <el-input v-model="dataForm.activeId" :placeholder="$t('mis.rebateComponents.activeId')" :disabled="detail"></el-input>
      </el-form-item>

      <el-form-item :label="$t('mis.rebateComponents.activity')" prop="beginDate">
        <el-date-picker
          v-model="dataForm.beginDate"
          type="datetime"
          :disabled="timeLimited"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('mis.common.startTime')"
        ></el-date-picker>&nbsp;{{$t('mis.rebateComponents.to')}}&nbsp;
        <el-date-picker
          prop="endDate"
          v-model="dataForm.endDate"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('mis.common.endTime')"
          @change="changeEndTime(dataForm.endDate)"
        ></el-date-picker><div style="color: red">{{$t('mis.rebateComponents.tips')}}</div>
      </el-form-item>
      <el-form-item :label="$t('mis.accountReward.activeStatus')" v-show="dataForm.id?true:false">
        <el-select v-model="dataForm.activeStatus" :placeholder="$t('mis.rebateComponents.all')" clearable>
          <el-option
            v-for="item in activeStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('mis.rebateComponents.effective')">
      </el-form-item>

   <!--   <el-form-item prop="lowAmount" label="首次入金金额>=">
        <el-input-number style="width:200px" v-model="dataForm.lowAmount" :disabled="detail"></el-input-number>
        美元
      </el-form-item>-->

      <el-form-item prop="highPoint" :label="$t('mis.rebateComponents.highAmount')" v-if="dataForm.activeType==1">
        <el-input-number style="width:200px" v-model="dataForm.highAmount" :disabled="detail"></el-input-number>
        {{$t('mis.rebateComponents.dollar')}}
      </el-form-item>

      <el-form-item prop="highPoint" :label="$t('mis.rebateComponents.highAmount2')" v-if="dataForm.activeType==0">
        <el-input-number style="width:200px" v-model="dataForm.highAmount" :disabled="detail"></el-input-number>
        {{$t('mis.rebateComponents.dollar')}}
      </el-form-item>

      <el-form-item prop="highAmount" :label="$t('mis.rebateComponents.highPoint')" v-if="dataForm.activeType==0">
        <el-input-number style="width:200px" v-model="dataForm.highPoint" :disabled="detail"></el-input-number>
        {{$t('mis.rebateComponents.dollar')}}
      </el-form-item>

      <el-form-item prop="expDay" :label="$t('mis.rebateComponents.expDay')">
        <el-input-number style="width:200px" v-model="dataForm.expDay" :disabled="detail"></el-input-number>
        {{$t('mis.rebateComponents.day')}}
      </el-form-item>

      <el-form-item prop="expDate" :label="$t('mis.rebateComponents.expDate')">
        {{$t('mis.rebateComponents.activeTime')}}
       <!-- <el-select v-model="dataForm.expDate" placeholder="全部" clearable>
          <el-option
            v-for="item in expOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>-->
      </el-form-item>

      <div class="border" style="display:flex;justify-content: space-between;">
        <div v-if="dataForm.activeType==1">{{$t('mis.rebateComponents.reward')}}</div>
        <div v-else-if="dataForm.activeType==0">{{$t('mis.rebateComponents.rebate')}}</div>
      </div>
      <el-tabs v-model="tabName" @tab-click="handleClick">
        <el-tab-pane :label="$t('mis.rebateComponents.min')" name="first">
          <div class="border" style="display:flex;justify-content: space-between;">
            <div style="color:#0096dc;cursor:pointer" @click="addSearchCondition('mMIN')">+{{$t('mis.rebateComponents.addCondition')}}</div>
          </div>
          <div class="condition-title">
            <ul>
              <li>{{$t('mis.rebateComponents.productType')}}</li>
              <li>{{$t('mis.rebateComponents.me')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.direct')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.indirect')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.quantity')}}</li>
              <li>{{$t('mis.bt.operation')}}</li>
            </ul>
          </div>

          <conditions
            v-for="(item,index) in min.value"
            :key="index"
            :listLiData="item"
            :level="'mMIN'"
            :activeType="dataForm.activeType"
            @deleteListData="deleteListData"
          ></conditions>

        </el-tab-pane>
        <el-tab-pane :label="$t('mis.rebateComponents.std')" name="second">
          <div class="border" style="display:flex;justify-content: space-between;">
            <div style="color:#0096dc;cursor:pointer" @click="addSearchCondition('mSTD')">+{{$t('mis.rebateComponents.addCondition')}}</div>
          </div>
          <div class="condition-title">
            <ul>
              <li>{{$t('mis.rebateComponents.productType')}}</li>
              <li>{{$t('mis.rebateComponents.me')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.direct')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.indirect')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.quantity')}}</li>
              <li>{{$t('mis.bt.operation')}}</li>
            </ul>
          </div>
          <conditions
            v-for="(item,index) in std.value"
            :key="index"
            :listLiData="item"
            :level="'mSTD'"
            :activeType="dataForm.activeType"
            @deleteListData="deleteListData"
          ></conditions>

        </el-tab-pane>
        <el-tab-pane :label="$t('mis.rebateComponents.vip')" name="third">
          <div class="border" style="display:flex;justify-content: space-between;">
            <div style="color:#0096dc;cursor:pointer" @click="addSearchCondition('mVIP')">+{{$t('mis.rebateComponents.addCondition')}}</div>
          </div>
          <div class="condition-title">
            <ul>
              <li>{{$t('mis.rebateComponents.productType')}}</li>
              <li>{{$t('mis.rebateComponents.me')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.direct')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.indirect')}}({{$t('mis.rebateComponents.dollar')}})</li>
              <li>{{$t('mis.rebateComponents.quantity')}}</li>
              <li>{{$t('mis.bt.operation')}}</li>
            </ul>
          </div>
          <conditions
            v-for="(item,index) in pla.value"
            :key="index"
            :listLiData="item"
            :level="'mVIP'"
            :activeType="dataForm.activeType"
            @deleteListData="deleteListData"
          ></conditions>

        </el-tab-pane>
      </el-tabs>
    </el-form>

    <template slot="footer">
      <el-button @click="visible = false" :disabled="detail">{{$t('mis.rebateComponents.cancel')}}</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="dataFormSubmitHandle()" :disabled="detail"
      >{{$t('mis.rebateComponents.confirm')}}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce";
    import conditions from "./components/conditions";
    import URL from '@/views/mis/util/url';
    import Qs from 'qs';

    export default {
        components: {
            conditions
        },
        data() {
            return {
                tabName: 'first',
                loading: false,
                addNum: 0,
                visible: false,
                timeLimited: false,
                detail:false,
                OldEndTime: "",
                expOptions: [{
                    value: 'activate',
                    label: '激活日期'
                }, {
                    value: 'register',
                    label: '开户日期'
                }],
                activeStatusOptions: [
                    {
                        value: 'DRAFT',
                        label: "待执行"
                    },
                    {
                        value: 'PENDING',
                        label: "执行中"
                    },
                    {
                        value: 'DISABLE',
                        label: "禁用"
                    },
                    {
                        value: 'END',
                        label: "已到期"
                    }
                ],
                dataForm: {
                    activeName: "",
                    beginDate: "",
                    endDate: "",
                    expDate: "",
                    activeId: "",
                    activeType: "0",
                    id: "",
                    product: ""
                },
                min: {
                    levelName: "迷你",
                    levelType: "mMIN",
                    rebateType: "1",
                    value: []
                },
                std: {
                    levelName: "标准",
                    levelType: "mSTD",
                    rebateType: "1",
                    value: []
                },
                pla: {
                    levelName: "金钻",
                    levelType: "mVIP",
                    rebateType: "1",
                    value: []
                }
            };
        },
        computed: {
            dataRule() {
                return {
                    activeName: [
                        {
                            required: true,
                            message: "必填项不能为空",
                            trigger: "blur"
                        }
                    ],
                    activeId: [
                        {
                            required: true,
                            message: "必填项不能为空",
                            trigger: "blur"
                        }
                    ],
                    beginDate: [
                        {
                            required: true,
                            message: "必填项不能为空",
                            trigger: "blur"
                        }
                    ],
                    endDate: [
                        {
                            required: true,
                            message: "必填项不能为空",
                            trigger: "blur"
                        }
                    ]
                };
            }
        },
        mounted(){
        },
        methods: {
            init(row) {
                this.clearFormData();
                if (row) {
                    this.dataForm.id = row.id
                }
                this.visible = true;
                this.$nextTick(() => {
                    this.$refs["dataForm"].resetFields();
                    if (this.dataForm.id) {
                        this.getInfo(row);
                    }
                });
            },
            clearFormData() {
                for (let key in this.dataForm) {
                    if (key != 'activeType') {
                        this.dataForm[key] = "";
                    }
                }
                let obj = {
                    name: "",
                    productType: "2",
                    me: "0",
                    direct: "0",
                    indirect: "0",
                    quantity: "",
                    index: this.addNum
                }
                this.min.value.length=0;
                this.std.value.length=0;
                this.pla.value.length=0;

                this.min.value.push(this.common.copy(obj));
                this.std.value.push(this.common.copy(obj));
                this.pla.value.push(this.common.copy(obj));
            },
            deleteListData(idIndex) {
                let levelList = [];
                if (idIndex.level == 'mMIN') {
                    levelList = this.min.value;
                } else if (idIndex.level == 'mSTD') {
                    levelList = this.std.value;
                } else if (idIndex.level == 'mVIP') {
                    levelList = this.pla.value;
                }
                let arrIndex = "";
                if (idIndex.index) {
                    for (let i in levelList) {
                        if (levelList[i].index == idIndex.index) {
                            arrIndex = i;
                        }
                    }
                }
                levelList.splice(arrIndex, 1);
            },
            changeEndTime(val) {
                if (this.dataForm.id) {
                    if (val < this.OldEndTime) {
                        this.dataForm.endDate = this.OldEndTime;
                        this.$message("结束时间只能往后延期，请谨慎操作");
                    }
                } else {
                    return;
                }
            },
            // 修改填充信息
            getInfo(row) {
                this.dataForm = {
                    ...this.dataForm,
                    ...row
                };
                this.OldEndTime = row.endDate;
                if (row.product != "") {
                    let productArray = JSON.parse(row.product);
                    for (let i in productArray) {
                        if (productArray[i].levelType == 'mMIN') {
                            this.min = productArray[i];
                        } else if (productArray[i].levelType == 'mSTD') {
                            this.std = productArray[i];
                        } else if (productArray[i].levelType == 'mVIP') {
                            this.pla = productArray[i];
                        }
                    }
                }

            },
            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(
                function () {
                    this.$refs["dataForm"].validate(valid => {
                        if (!valid) {
                            return false;
                        }
                        let productArray = [];
                        this.min.rebateType=this.dataForm.activeType;
                        this.std.rebateType=this.dataForm.activeType;
                        this.pla.rebateType=this.dataForm.activeType;
                        productArray.push(this.min);
                        productArray.push(this.std);
                        productArray.push(this.pla);
                        this.dataForm.product = JSON.stringify(productArray);
                        this.loading = true;
                        //根据是否包含id更新还是添加
                        this.dataChanage(URL.rebateActivity.edit, this.dataForm, res => {
                            this.loading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "提交成功",
                                    type: "success",
                                    duration: 500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$emit("refreshDataList");
                                    }
                                });
                            } else {
                                this.$message.error("提交失败");
                            }
                            this.visible = false;
                        })
                    });
                },
                1000,
                {leading: true, trailing: false}
            ),
            addSearchCondition(type) {
                let levelList = [];
                if (type == 'mMIN') {
                    levelList = this.min.value;
                } else if (type == 'mSTD') {
                    levelList = this.std.value;
                } else if (type == 'mVIP') {
                    levelList = this.pla.value;
                }
                if (levelList.length == 0){
                    this.addNum=0;
                }else {
                    this.addNum=this.addNum+1;
                }
                levelList.push({
                    name: "",
                    productType: "2",
                    me: "0",
                    direct: "0",
                    indirect: "0",
                    quantity: "",
                    index: this.addNum
                });
                this.addNum++;
            }
        }
    };
</script>
<style lang="scss" scoped>
  .condition-title {
    ul {
      display: flex;
      padding: 20px 0;

      li {
        width: 180px;
        text-align: center;
        margin-right: 20px;
      }
    }
  }

  ul,
  li {
    list-style: none;
  }
</style>
